import { motion } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';
import { useObserver } from '../../../../CodesThatsGottaGoSomewhereElse';
import { Matrix } from '../../../../platform/geom/Matrix';
import { useResolve } from '../../../Container';
import { Counter } from '../../../common/Users';
import { Flexer } from '../../../dashboard/elements/LayoutElements';
import { Hat } from '../../participants/Hat';
import { Origin } from '../../visualization/Origin';
import { Pawn } from './Pawn';
import { PawnManager } from './PawnManager';

const CounterMount = styled(motion.div)`
    transform-origin: left top;
    width: 0;
    height: 0;
    will-change: transform;
`;

const CounterFrame = styled.div`
    position: absolute;
    left: -20px;
    top: -20px;
    width: 40px;
    height: 40px;

    & > svg {
        position: absolute;
        top: -2.2rem;
        left: 50%;
        width: 3rem;
        height: 3rem;
        transform: translateX(-50%);
    }
`;

const RenderAdapter = React.memo<{ pawn: Pawn }>(({ pawn }) => {
    const { overrides, ...props } = useObserver(pawn);
    const { adapter, color } = { ...props, ...(overrides ?? {}) };
    if (!pawn.visible) return null;

    const [_id, outline] = adapter;
    if (!outline) return null;

    const lw = 4;

    const composite = outline;// .concat(link);
    const fr = composite.bounds();
    const ps = fr.topLeft();
    const sz = fr.size().add([lw * 2, lw * 2]);
    const tc = composite.transform(Matrix.translate(ps.multiply(-1)).translate(lw, lw));

    const d = tc.toString();

    const styling: any = {
        position: 'absolute',
        transform: Matrix.translate(ps).translate(-lw, -lw),
    };

    return <svg width={sz.w} height={sz.h} style={styling}>
        <g>
            <path fill="none" stroke={color} strokeWidth={lw} d={d} />
        </g>
    </svg>;
});

const RenderCounter = React.memo<{ pawn: Pawn }>(({ pawn }) => {
    const { overrides, ...props } = useObserver(pawn);
    const { x, y, opacity, label, color, imageUrl, hat } = { ...props, ...(overrides ?? {}) };

    const style = {
        transformOrigin: 'left top',
        width: 0,
        height: 0,
        willChange: 'transform',
    };

    return <motion.div style={style} animate={{ x, y, opacity }} transition={{ type: 'tween', ease: 'linear', duration: .1 }}>
        {pawn.visible && <CounterFrame>
            <Hat type={hat}>
                <Counter size={40} unit="px" color={color} photo={imageUrl}>
                    {label}
                </Counter>
            </Hat>
        </CounterFrame>}
    </motion.div>;
});

const RenderPawn = (props: { pawn: Pawn }) => <>
    <RenderAdapter {...props} />
    <RenderCounter {...props} />
</>;

export const PawnLayer = () => {

    const pawns = useObserver(useResolve(PawnManager));

    return <Flexer id="pawn-layer" inset zIndex="1" pointerOff>
        <Origin>
            {pawns.map(x => <RenderPawn key={x.id} pawn={x} />)}
        </Origin>
    </Flexer>;
};
